export default {"src":"https://web.cdn.greenlight.com/2.196.3/_next/static/media/white-bullet.e327eea5.svg","height":12,"width":9};